import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import HomeIcon from "@mui/icons-material/Home";
import { PeopleAlt } from "@mui/icons-material";

import { DarkGrey, Grey, White } from "../theme/colors";

const StyledBottomNavigationAction = styled(BottomNavigationAction)`
  color: ${Grey} !important;
  flex: 1;
  max-width: none;

  &.Mui-selected {
    color: ${White} !important;
  }

  .MuiBottomNavigationAction-iconOnlyWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export default function LabelBottomNavigation({ activeTab, onTabChange }) {
  const location = useLocation(); // Get current path
  const navigate = useNavigate(); // Navigation function

  const [value, setValue] = React.useState(location.pathname);

  // Sync state with current route
  React.useEffect(() => {
    setValue(location.pathname);
  }, [location]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        position: "relative",
      }}
    >
      <BottomNavigation
        component="div"
        showLabels
        value={value}
        onChange={handleChange}
        sx={{
          backgroundColor: DarkGrey,
          boxShadow: "none",
          width: "100%",
          height: "80px", // 👈 increase total navbar height
          display: "flex",
          justifyContent: "space-evenly",
          alignItems: "flex-start",
          paddingTop: "15px",
        }}
      >
        <StyledBottomNavigationAction
          value="/home"
          icon={<HomeIcon />}
          style={{ fontSize: "25px" }}
          disableRipple
        />

        <StyledBottomNavigationAction
          value="/friends"
          icon={<PeopleAlt style={{ fontSize: "25px" }} />}
          disableRipple
        />
        <StyledBottomNavigationAction
          value="/profile"
          icon={<AccountCircleIcon style={{ fontSize: "25px" }} />}
          disableRipple
        />
      </BottomNavigation>
    </div>
  );
}
